import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/shared";
import { business, fullAddress, routes } from "@/lib/site";

const Block = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-heading font-bold text-navy text-xl sm:text-2xl mb-3">{title}</h2>
    <div className="text-ink leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Terms() {
  return (
    <>
      <SEO
        path={routes.terms}
        title="Terms & Conditions | Dr. Satyam's Pain Healthcare, Varanasi"
        description="Terms and conditions for using the Dr. Satyam's Pain Healthcare website, Varanasi."
      />
      <PageHero title="Terms & Conditions" breadcrumb={[{ label: "Terms & Conditions" }]} />
      <section className="bg-white py-16 lg:py-20">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <p className="text-ink leading-relaxed mb-8">
            These Terms &amp; Conditions govern your use of the {business.clinicName} website.
            By accessing this website, you accept these terms.
          </p>
          <Block title="Medical Disclaimer">
            <p>The content on this website is for general information and awareness only. It is not
            medical advice and is not a substitute for professional consultation, diagnosis or treatment.
            Always seek the advice of a qualified professional regarding any health concern.</p>
          </Block>
          <Block title="No Guaranteed Outcomes">
            <p>Individual results vary. Nothing on this website should be interpreted as a promise or
            guarantee of a specific treatment outcome. Care approaches are recommended based on an
            individual assessment.</p>
          </Block>
          <Block title="Appointments & Enquiries">
            <p>Appointment requests submitted through this website are enquiries and are confirmed only
            after communication with the clinic. Clinic timings and availability may change.</p>
          </Block>
          <Block title="Intellectual Property">
            <p>All content, branding and images on this website are the property of {business.clinicName}
            unless otherwise stated, and may not be reproduced without permission.</p>
          </Block>
          <Block title="Contact">
            <p>For any questions about these terms, contact us at {business.phoneDisplay} or visit us at {fullAddress}.</p>
          </Block>
        </div>
      </section>
    </>
  );
}
